//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { readableNumber } from '@utils/readableNumber';

export const calculateTruncRowPercentageLabel = (outcomeRows: number, processedRows: number): string => {
  const percentageVal = Math.round((outcomeRows / processedRows) * 1000) / 10;
  return `${ percentageVal ? percentageVal : 0  }% (${readableNumber(outcomeRows)})`;
};
